import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../encoding/AbstractEncoder.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NoOpEncoderClass;
function NoOpEncoder() {
  if (NoOpEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      static q1z() {
        NoOpEncoder_instance = null;
        var $this = this.w1r();
        NoOpEncoder_instance = $this;
        $this.p1z_1 = EmptySerializersModule();
        return $this;
      }
      s1r() {
        return this.p1z_1;
      }
      y1r(value) {
        return Unit_instance;
      }
      z1r() {
        return Unit_instance;
      }
      a1s(value) {
        return Unit_instance;
      }
      b1s(value) {
        return Unit_instance;
      }
      c1s(value) {
        return Unit_instance;
      }
      d1s(value) {
        return Unit_instance;
      }
      e1s(value) {
        return Unit_instance;
      }
      f1s(value) {
        return Unit_instance;
      }
      g1s(value) {
        return Unit_instance;
      }
      h1s(value) {
        return Unit_instance;
      }
      i1s(value) {
        return Unit_instance;
      }
      j1s(enumDescriptor, index) {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'NoOpEncoder');
    NoOpEncoderClass = $;
  }
  return NoOpEncoderClass;
}
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance === VOID)
    NoOpEncoder().q1z();
  return NoOpEncoder_instance;
}
//region block: exports
export {
  NoOpEncoder_getInstance as NoOpEncoder_getInstance2wgh00a9s97su,
};
//endregion

//# sourceMappingURL=NoOpEncoder.mjs.map
